import React from 'react';
import styles from './TopDetails.module.scss';
import LogoSquare
  from 'gui/components/listPage/components/ad/components/genericImageSquare/components/logoSquare';
import ShareButton from 'gui/pages/mainRouter/pages/ad/components/commons/shareButton';

interface ITopDetailsProps {
  title?: string;
  logoSrc?: any;
  logoTitle?: string;
  children?: any;
}

const TopDetails = (props: ITopDetailsProps) => {
  return (
    <div className={styles.topDetails}>
      <div className={styles.detailsTopRow}>
        <div className={styles.detailsTopRowSide}>
          <h2 className={styles.title}>{props.title}</h2>
          <LogoSquare
            logoSrc={props.logoSrc}
            logoTitle={props.logoTitle}
          />
        </div>
        <ShareButton shareButtonText={''}/>
      </div>
      <div className={styles.details}>
        {props.children}
      </div>
    </div>
  );
};

TopDetails.defaultProps = {
  title: '',
  logo: null,
};

export default React.memo(TopDetails);
